import { Flex } from "antd";
import styled from "styled-components";

export const SupplierLoginWrap = styled(Flex)`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  font-family: var(--app-font-family) !important;

  background-color: #FFFFFF;
  background-image: linear-gradient(180deg, #FFFFFF 0%, #E7FAF5FF 50%, #EBF9E3FF 100%);

  & .login--title {
    font-size: 38px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  & .login--container {
    padding: 30px;
    border: 1px solid #ACCBF8FF;
    border-radius: 10px;
  }
`;